import { useTranslation } from 'react-i18next';

import {
  FiltersWrapper,
  InputContainer,
  SearchInputContainer,
} from '../../../SimplePage/Filters';
import Checkbox from '../../../UI/Checkbox/Checkbox';
import IconInput from '../../../UI/IconInput/IconInput';
import { MainSelect } from '../../../UI/MainSelect/MainSelect';
import {
  membersTypesOptions,
  renewStatusOptions,
} from './aaMembersFilters.const';
import { useAAMembersFilters } from './aaMembersFilters.hooks';
import {
  AAMembersFiltersProps,
  AAMembersListFilters,
} from './aaMembersFilters.models';

const AAMembersFilters = ({
  availableFilters,
  standardPricing,
}: AAMembersFiltersProps) => {
  const { t } = useTranslation();
  const {
    filters,
    onFilterChangeHandler,
    plansOptions,
    subscriptionsListOptions,
  } = useAAMembersFilters({ standardPricing });

  const filtersComponents = availableFilters.map((filter) => {
    switch (filter) {
      case AAMembersListFilters.Search:
        return (
          <SearchInputContainer key={AAMembersListFilters.Search}>
            <IconInput
              defaultIcon="search"
              onChange={(evt) =>
                onFilterChangeHandler(evt, AAMembersListFilters.Search)
              }
              placeholder={t('filters.search-by')}
              value={filters.search}
            />
          </SearchInputContainer>
        );
      case AAMembersListFilters.Plan:
        return (
          <InputContainer key={AAMembersListFilters.Plan}>
            <MainSelect
              currentValue={filters.plan}
              isClearable
              isMulti
              onChange={(evt: any) =>
                onFilterChangeHandler(evt, AAMembersListFilters.Plan)
              }
              options={plansOptions}
              placeholder={t('filters.plan')}
            />
          </InputContainer>
        );
      case AAMembersListFilters.MemberType:
        return (
          <InputContainer key={AAMembersListFilters.MemberType}>
            <MainSelect
              currentValue={filters.memberType}
              isClearable
              isMulti
              onChange={(evt: any) =>
                onFilterChangeHandler(evt, AAMembersListFilters.MemberType)
              }
              options={membersTypesOptions}
              placeholder={t('filters.member')}
            />
          </InputContainer>
        );
      case AAMembersListFilters.RenewStatus:
        return (
          <InputContainer key={AAMembersListFilters.RenewStatus}>
            <MainSelect
              currentValue={filters.renewStatus}
              isClearable
              onChange={(evt: any) =>
                onFilterChangeHandler(evt, AAMembersListFilters.RenewStatus)
              }
              options={renewStatusOptions}
              placeholder={t('filters.renew-status')}
            />
          </InputContainer>
        );
      case AAMembersListFilters.SubscriptionId:
        return (
          <InputContainer key={AAMembersListFilters.SubscriptionId}>
            <MainSelect
              currentValue={filters.subscriptionId}
              isClearable
              isMulti
              onChange={(evt: any) =>
                onFilterChangeHandler(evt, AAMembersListFilters.SubscriptionId)
              }
              options={subscriptionsListOptions}
              placeholder={t('filters.subscription')}
            />
          </InputContainer>
        );
      case AAMembersListFilters.OversubscribedOnly:
        return (
          <Checkbox
            key={AAMembersListFilters.OversubscribedOnly}
            checked={!!filters.oversubscribedOnly}
            onChange={(evt: any) =>
              onFilterChangeHandler(
                evt,
                AAMembersListFilters.OversubscribedOnly,
              )
            }
            label={t('filters.only-subscribed')}
          />
        );
      default:
        return null;
    }
  });

  return <FiltersWrapper>{filtersComponents}</FiltersWrapper>;
};

export default AAMembersFilters;
